<template>
  <div id="scanner">
    <qrcode-stream :camera="camera" :track="paintBoundingBox">
      <img v-if="onValid" class="loader" src="assets/loader_animhead.gif" alt="">
    </qrcode-stream>

    <div id="cameraAndPicture">
      <canvas class="raster" id="fullsize"></canvas>
      <canvas class="raster" id="thumbnail"></canvas>
      <div class="actions">
        <font-awesome-icon color="#00d6ff" id="switch" size="md" class="" @click="onSwitch" icon="exchange-alt"
                           v-if="deviceCheck(['mobile','tablet'])"/>
        <!--        <div class="action torch" id="torch">Torch</div>-->
        <!--        <font-awesome-icon color="#00d6ff" id="scan" size="lg" v-if="mode==='camera'" @click="hideFilter" class="" icon="qrcode"/>-->
      </div>
    </div>
    <ScanCard v-if="scancard" :scancard="scancard" @active-mask="setScancard"/>
  </div>

</template>

<script>
import CameraControls from "../Camera/Controls/CameraControls";
import ScanCard from "../Modals/Modal/ModalScanCard";
import {store} from '../../store/store';

import SavePicture from "../Camera/Widgets/SavePicture";
import {mapState} from "vuex";


export default {
  name: 'Scanner',
  components: {
    CameraControls,
    SavePicture,
    ScanCard
  },
  data() {
    return {
      store,
      streamingCanvas: null,
      media: '',
      camera: "auto",
      qrcode_uid: this.$route.params.qrcode_uid,
      currentRoute: this.$route.name,
      scancard: null,
      mode: 'scan',
      onValid: false
    }
  },
  computed: {
    ...mapState([
      "user",
      "masks",
      "logged"
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "LaunchScreen"});
    // const MaskCanvas = document.getElementsByClassName('jeeFaceFilterCanvas');


    document.querySelector('.qrcode-stream-overlay').style.transform = "translate(0, 0) rotateY(180deg)";


  },
  methods: {
    deviceCheck(arrayValue) {
      let device = getDevice()
      return arrayValue.includes(device)
    },

    setScancard(playload) {
      this.scancard = null
      if (playload.mask) {
        this.showFilter()
        setTimeout(function () {
          load_mask(playload.mask.name, playload.texture.image)
        }, 1200)
      }
    },
    onSwitch() {
      this.camera = this.camera === 'auto' || this.camera === 'rear' ? 'front' : 'rear';
      if (this.camera === 'rear') {
        document.querySelector('.qrcode-stream-overlay').style.transform = "translate(0, 0) rotateY(0deg)";
      } else {
        document.querySelector('.qrcode-stream-overlay').style.transform = "translate(0, 0) rotateY(180deg)";

      }


    },
    async onDecode(decodeString) {
      // document.location.href=decodeString.rawValue
      this.scancard = decodeString
    },
    timeout(ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    validQrcode(detectedCodes, ctx) {
      if (!this.scancard) {
        this.onValid = true;
        let qrcodeValue = detectedCodes[0].rawValue
        let url = new URL(qrcodeValue)

        if (url.hostname === 'animhead.fr' && url.protocol === 'https:' && url.pathname.split('/')[1] === 'masque') {
          this.onValid = false
          this.onDecode({url})
          return true
        } else {
          this.onValid = false
          this.onDecode({url})
          return true

        }

      } else {
        this.onValid = false

      }

    },
    paintCenterText(detectedCodes, ctx) {
      let contentScan = document.querySelector('.qrcode-stream-overlay');

      for (const detectedCode of detectedCodes) {
        const {boundingBox, rawValue} = detectedCode
        const centerX = Math.abs((boundingBox.x + boundingBox.width / 2) - ctx.canvas.width)
        const centerY = boundingBox.y + boundingBox.height / 2
        let contentTop = contentScan.offsetTop;
        let contentBottom = contentTop + contentScan.offsetHeight
        let contentLeft = contentScan.offsetLeft;
        let contentRight = contentLeft + contentScan.offsetWidth

        if ((boundingBox.x > contentLeft && boundingBox.x < contentRight) && (boundingBox.y > contentTop && boundingBox.y < contentBottom)) {


          const fontSize = Math.max(12, 50 * boundingBox.width / ctx.canvas.width)

          ctx.font = `bold ${fontSize}px sans-serif`
          ctx.textAlign = "center"
          ctx.lineWidth = 3
          ctx.strokeStyle = '#35495e'
          ctx.strokeText(detectedCode.rawValue, centerX, centerY)
          ctx.fillStyle = '#5cb984'
          ctx.fillText(rawValue, centerX, centerY)
          let img = new Image();   // Crée un nouvel élément Image
          img.src = './assets/logo.png';
          ctx.drawImage(img, Math.abs((boundingBox.x + boundingBox.width) - ctx.canvas.width), boundingBox.y, boundingBox.width, boundingBox.height)

          this.onDecode(detectedCode)
        }
      }
    },
    paintBoundingBox(detectedCodes, ctx) {

      for (const detectedCode of detectedCodes) {
        const {boundingBox: {x, y, width, height}} = detectedCode
        ctx.lineWidth = 4
        ctx.strokeStyle = '#2381ef'
        ctx.strokeRect(Math.abs((x + width) - ctx.canvas.width), y, width, height)
      }
      this.paintCenterText(detectedCodes, ctx)
    },
  }
}
</script>

<style scoped>

#mediaPreview {
  width: 100vw;
}

body {
  background-color: #000;
}

#deviceready {
  height: 100%;
}

#openMouthInstruction {
  display: none;
}


.image > img {
  width: 100%;
}

.gallery > * {
  margin: 4px;
}

.loader {
  display: block;
  width: 100%;

}

@media screen and (min-aspect-ratio: 1/1) and (min-width: 400px) {
  .app {

  }
}

/* Canvas */
canvas.raster {
  top: 0;
  left: 0;
  position: absolute;
}

/* Actions */
.actions {
  padding: 4px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  right: 15px;
  top: 5px;
  position: fixed;
}

.actions svg {
  width: 1.8em;
  height: 1.8em;
}

.actions > * {
  margin: 10px 0px;
}

div.action {
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
  position: relative;
}


.qrcode-stream-camera {
  transform: translate(0, 0) rotateY(180deg);
}

@media screen and (max-width: 750px) {
  .actions {
    top: env(safe-area-inset-top);
    right: 10px;
  }

}

</style>
